import React from 'react';
import './Hero.css';
import logo from '../../assets/images/logo.jpg';
import appStoreBadge from '../../assets/images/app-store-badge.svg';
import googlePlayBadge from '../../assets/images/GooglePlay-store-badge.svg';
import { trackButtonClick } from '../../utils/analytics';

const Hero: React.FC = () => {
  const handleAppStoreClick = () => {
    trackButtonClick('app_store', 'hero', 'download_click');
  };

  const handleGooglePlayClick = () => {
    trackButtonClick('google_play', 'hero', 'download_click');
  };

  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="hero-bolt">⚡</span> Gelwel — Social & Lifestyle for the Modern You.
          </h1>
          <p className="hero-tagline">
            Connect with your vibe. Express your world.
          </p>
          <div className="hero-buttons">
            <div className="hero-badge-container-appstore">
              <a href="#download" className="hero-badge-link" onClick={handleAppStoreClick}>
                <img
                  src={appStoreBadge}
                  alt="Download on the App Store"
                  className="hero-badge-appstore"
                />
              </a>
            </div>
            <div className="hero-badge-container-playstore">
              <a href="#download" className="hero-badge-link" onClick={handleGooglePlayClick}>
                <img
                  src={googlePlayBadge}
                  alt="Get it on Google Play"
                  className="hero-badge-playstore"
                />
              </a>
            </div>
          </div>
        </div>
        <div className="hero-visual">
          <div className="hero-mockup">
            <img
              src={logo}
              alt="Gelwel Logo"
              className="hero-logo"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
